import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

import auth from "./modules/auth";
import settings from "./modules/settings";
import account from "./modules/account";
import identity from "./modules/identity";
import tenant from "./modules/tenant";

import type { IRootState } from "@/types/store";

// let configToken = process.env.VUE_APP_CLIENT_KEY;
const configToken = 'GHJBgsdbfjgubhj85^&I&%RbklXGcyb9r0((%$vhb7r>"":{{}||\\^%TFDServgvvvjhJHVFvCFgf21!@#$%^&*(_?=)|?!1`@thudcvhjiy';

let ls = new SecureLS({
  encodingType: "des",
  isCompression: false,
  encryptionSecret: configToken
});

// Create store
export default createStore<IRootState>({
  modules: {
    auth,
    settings,
    account,
    identity,
    tenant
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ]
});
